/* Theme-local Giftship integration via its documented settings-loaded event.
 * Register BEFORE app startup. Never writes app/admin settings or entitlements.
 */
(function () {
  'use strict';
  document.addEventListener('giftship.settings.loaded', function () {
    if (!window.Gs || !Gs.settings || !Gs.settings.options) return;
    var settings = Gs.settings;
    var options = settings.options;
    var page = Gs.state.page_type;
    if (page !== 'cart' && page !== 'product') return;
    var dateRules = Object.assign({}, options.datepicker);
    window.ffgAdvanceDateRules = dateRules;
    // Legacy fields arrive as server-rendered HTML. Remove only those legacy
    // controls before Giftship mounts them, preserving other app markup/features.
    var template = document.createElement('template');
    template.innerHTML = settings._appHtml || '';
    template.content.querySelectorAll('.gs__gift-checkbox').forEach(function (input) {
      var toggle = input.closest('.gs__toggle-feature-item');
      if (toggle) toggle.remove();
    });
    template.content.querySelectorAll('#gsDatepickerRow').forEach(function (row) { row.remove(); });
    settings._appHtml = template.innerHTML;
    options.message.enable = 0;
    options.datepicker.enable = 0;
    if (page === 'cart') {
      var sets = settings.cart_options || [];
      if (sets.some(function (set) {
        return set.id !== 'ffg-order-details' && (set.blocks || []).some(function (block) {
          return block.type === 'message' || block.type === 'datepicker';
        });
      })) {
        window.ffgOrderDetailsError = 'Another Giftship date/message option set is active. Please contact the shop before checking out.';
        Gs.options = settings.options;
        return;
      }
      var conditions = {display_rule_type: 'all', display_rules: [], cart_display_rules: []};
      var blocks = [
        {id: 'ffg-order-date', type: 'datepicker', conditions: conditions, settings: Object.assign({}, dateRules, {
          name: 'Delivery Date', label: 'Delivery / pickup date', placeholder: 'Select a date',
          help: 'Today is a delivery-only request at the $69.99 same-day rate, subject to staff confirmation. Pickup requires an advance date and is unavailable Sundays.',
          // Start with today so a saved request can load. The cart controller
          // restores advance restrictions on all other dates before becoming ready.
          lead_time: '0', cutoff_time: '24:00:00', add_disallowed_to_lead: false,
          required: true, enable_time: false
        })},
        {id: 'ffg-order-message', type: 'message', conditions: conditions, settings: {
          name: 'gift', to_name: 'To', from_name: 'From', message_name: 'Message',
          show_to: true, show_from: true, show_message: true, show_labels: true,
          required: '0', display_type: 'display_is_gift', message_location: 'per_order',
          limit_characters: true, max_characters: 80, show_additional: false,
          default_message: '', content_above: ''
        }}
      ];
      settings.cart_options = sets.filter(function (set) {return set.id !== 'ffg-order-details';}).concat([{
        id: 'ffg-order-details', blocks: blocks, block_order: blocks.map(function (b) {return b.id;}), translations: [],
        display_settings: {title: 'Order details', enabled: true, display_location: 'single', display_on_all_carts: true, display_on_cart_products: []}
      }]);
    }
    // Required by Giftship's documented hook when settings/options are modified.
    Gs.options = settings.options;
  });
}());
